import React from 'react';
import { connect } from 'react-redux';
import { movil } from '../app-movil';

const mapState = (state) => {
	return {
		paso: state.miPerfil.pasoContasena,
		pregunta1: state.miPerfil.preguntaUno,
		pregunta2: state.miPerfil.preguntaDos,
		preguntas1: state.catalogos.catalogoPregunta1,
		preguntas2: state.catalogos.catalogoPregunta2
	};
};

const mapDispatch = (dispatch) => {
	return {
		resetSiguientePreguntas: () => {
			dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_PREGUNTAS" });
		},
		pasoSiguientePreguntas: () => {
			dispatch({ "type": "MI_PERFIL_PASO_SIGUIENTE_PREGUNTAS" });
		},
		setP1: (obj) => {
			dispatch({ "type": "MI_PERFIL_SET_P1_EDIT", "p": obj.p, "r": obj.r });
		},
		setP2: (obj) => {
			dispatch({ "type": "MI_PERFIL_SET_P2_EDIT", "p": obj.p, "r": obj.r });
		},
		addEvento: (evento) => {
			dispatch({ "type": "MI_PERFIL_SET_EVENT", "evento": evento});
		}
	};
};

class PasoUnoPreguntas extends React.Component {
	state = {
		inputClassPreguntaUno: "input-wrap ver-input",
		inputClassPreguntaDos: "input-wrap ver-input",
		inputActivePreguntaUnoEdit: "",
		inputActivePreguntaDosEdit: "",
		inputPreguntaUnoType: "password",
		inputPreguntaDosType: "password",
		errorP1: false,
		errorP2: false,
		errorPreguntaUnoEdit: false,
		errorMsjPreguntaUnoEdit: "",
		errorPreguntaDosEdit: false,
		errorMsjPreguntaDosEdit: "",
		respuestaUnoEdit: "",
		RespuestaDosEdit: "",
		preguntaUnoEdit: this.props.pregunta1,
		preguntaDosEdit: this.props.pregunta2,
		errorRespuestasIguales: false
	}
	
	componentDidMount(){
		var $this = this;
		$(document).ready(()=>{
			$('#modal-editar-preguntas').on('show.bs.modal', function (e) {
				$this.setState({errorRespuestasIguales:false});
				$this.setState({errorP1:false});
				$this.setState({errorP2:false});
				$this.setState({errorPreguntaUnoEdit:false});
				$this.setState({errorPreguntaDosEdit:false});
			});
		});
	}

	handleFocus = (event) => {
		let id = event.target.id;
		this.setState({errorRespuestasIguales: false});
		switch(id) {
		case "inputRespuestaUnoEdit":
			this.setState({inputActivePreguntaUnoEdit: "input-active"});
			this.setState({errorPreguntaUnoEdit: false});
			this.setState({errorMsjPreguntaUnoEdit: ""});
			break;
		case "inputRespuestaDosEdit":
			this.setState({inputActivePreguntaDosEdit: "input-active"});
			this.setState({errorPreguntaDosEdit: false});
			this.setState({errorMsjPreguntaDosEdit: ""});
			break;
		}
	}
	handleBlur = (event) => {
		let id = event.target.id;
		let valor = event.target.value;
		switch(id) {
		case "inputRespuestaUnoEdit":
			this.setState({inputActivePreguntaUnoEdit: valor ? "input-active" : ""});
			this.setState({respuestaUnoEdit: valor});
			break;
		case "inputRespuestaDosEdit":
			this.setState({inputActivePreguntaDosEdit: valor ? "input-active" : ""});
			this.setState({RespuestaDosEdit: valor});
			break;
		}
	}
	toggleType = (event) => {
		let id = event.target.id;
		let type;
		switch(id) {
		case "ojoRespuestaUno":
			type = this.state.inputPreguntaUnoType;
			this.setState({inputPreguntaUnoType: type == "password" ? "text" : "password"});
			this.setState({inputClassPreguntaUno: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input"});
			break;
		case "ojoRespuestaDos":
			type = this.state.inputPreguntaDosType;
			this.setState({inputPreguntaDosType: type == "password" ? "text" : "password"});
			this.setState({inputClassPreguntaDos: type == "password" ? "input-wrap visible-input" : "input-wrap ver-input"});
			break;
		}
	}
	setSelectValue = (event) => {
		let id = event.target.id;
		//console.log(id);
		let valor = event.target.value;
		//console.log(valor);
		switch(id) {
		case "pregunta_uno_edit":
			this.setState({preguntaUnoEdit: valor});
			break;
		case "pregunta_dos_edit":
			this.setState({preguntaDosEdit: valor});
			break;
		}
	}
	okPreguntas = () => {
		let mensaje = {"return": "miPerfil", "proceso": "cambioPreguntas"};
		movil("cambioPreguntas", mensaje);
		this.props.resetSiguientePreguntas();
		this.setState({inputClassPreguntaUno: "input-wrap ver-input"});
		this.setState({inputClassPreguntaDos: "input-wrap ver-input"});
		this.setState({inputClassContrasenaPreguntasEdit: "input-wrap"});
		this.setState({inputActivePreguntaUnoEdit: ""});
		this.setState({inputActivePreguntaDosEdit: ""});
		this.setState({inputActiveContrasenaPreguntasEdit: ""});
		this.setState({inputPreguntaUnoType: "password"});
		this.setState({inputPreguntaDosType: "password"});
		this.setState({inputContrasenaPreguntasEditType: "password"});
		this.setState({respuestaUnoEdit: ""});
		this.setState({RespuestaDosEdit: ""});
		this.setState({contrasenaPreguntasEdit: ""});
		this.refs.p1.value = "";
		this.refs.p2.value = "";
		$("#modal-editar-preguntas").modal("toggle");
		this.props.addEvento("Cancelar-ModPreguntas");
	}
	checkPreguntas = () => {
		let p1 = this.state.preguntaUnoEdit;
		let r1 = this.state.respuestaUnoEdit;
		let p2 = this.state.preguntaDosEdit;
		let r2 = this.state.RespuestaDosEdit;
		this.setState({errorP1: false});
		this.setState({errorP2: false});
		let ok = true;
		if(p1 == 0) {
			this.setState({errorP1: true});
			ok = false;
		}
		
		if(!r1 || !r2) {
			this.props.addEvento("CampoRequerido-ModPreguntas");
		}
		if(!r1) {
			this.setState({errorPreguntaUnoEdit: true});
			this.setState({errorMsjPreguntaUnoEdit: "Campo requerido."});
			//this.props.addEvento("CampoRequerido-ModPreguntas");
			ok = false;
		}
		if(p2 == 0) {
			this.setState({errorP2: true});
			ok = false;
		}
		if(!r2) {
			this.setState({errorPreguntaDosEdit: true});
			this.setState({errorMsjPreguntaDosEdit: "Campo requerido."});
			//this.props.addEvento("CampoRequerido-ModPreguntas");
			ok = false;
		}
		if(r1.length==0){
			this.setState({errorPreguntaUnoEdit: true});
			this.setState({errorMsjPreguntaUnoEdit: "Campo requerido."});
			ok = false;
			
		}else if(r1.trim().length == 0){
			this.setState({errorPreguntaUnoEdit: true});
			this.setState({errorMsjPreguntaUnoEdit: "Las respuestas no puede ser solo espacios."});
			ok = false;
		}
		
		if(r2.length==0){
			this.setState({errorPreguntaDosEdit: true});
			this.setState({errorMsjPreguntaDosEdit: "Campo requerido."});
			ok = false;
		}else if(r2.trim().length == 0){
			this.setState({errorPreguntaDosEdit: true});
			this.setState({errorMsjPreguntaDosEdit: "Las respuestas no puede ser solo espacios."});
			ok = false;
		}
		if(r1 == r2) {
			this.setState({errorRespuestasIguales: true});
			ok = false;
		}
		if(ok) {
			this.props.setP1({p: p1, r: r1});
			this.props.setP2({p: p2, r: r2});
			this.props.addEvento("RespValidas-ModPreguntas");
			this.props.pasoSiguientePreguntas();
		}
	}
	handleChange = (event) => {
		let value = event.target.value;
		/*for (var i = 0; i < value.length; i++) {
			if(value[i] == " ") {
				event.target.value = value.replace(value[i], "");
				value = event.target.value;
				i=-1;
			}
		};*/
		this.setState({errorRespuestasIguales: false});
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			preguntaUnoEdit: nextProps.pregunta1,
			preguntaDosEdit: nextProps.pregunta2,
		});
	};

	render() {
		return <div>
			<h5>
				<i>
					<img src={ require("../img/icon-question.png") } />
				</i>Actualizar preguntas secretas
			</h5>
			{ this.state.errorRespuestasIguales &&
				<div className="msj-warning">
					<i className="no-pad"><img src={ require("../img/exclamation-naranja.png") } /></i>
					<span>
						Tus respuestas no deben ser iguales. Favor de verificar.
					</span>
				</div>
			}
			<hr className="mt-34" />
			<div className="texto-17">
				<p>Las preguntas secretas te ayudarán a desbloquear tu contraseña en caso de olvido y también se te solicitarán para autorizar algunas transacciones, podrás utilizarlas en la app Soy Cliente GNP.</p>
			</div>
			<div className="row">
				<div className="col-xs-12 col-md-10 col-md-offset-1">
					<div className="row">
						<div className="col-xs-12 mt-34">
							<div className="input-wrap">
								<label>Pregunta secreta 1</label>
								<span className="clearfix input-active">
								 {/* { this.props.pregunta1 != "" && */}
								 { true &&
									<select defaultValue={this.props.pregunta1} name="" id="pregunta_uno_edit" className="col-xs-1" onChange={this.setSelectValue} >
										<option value="0">Selecciona una pregunta</option>
										{ this.props.preguntas1.map((item,i) => 
											<option key={i} value={item.id}>{item.descripcion}</option>
										)}
									</select>
								 }
								</span>
								{ this.state.errorP1 &&
									<div className="error-wrap">
										<div className="msj-error">
											<p>Campo requerido.</p>
										</div>
									</div>
								}
							</div>
						</div>
						<div className="col-xs-12">
							<div className={this.state.inputClassPreguntaUno}>
								<label>Respuesta</label>
								<span className={this.state.inputActivePreguntaUnoEdit}>
									<input ref="p1" id="inputRespuestaUnoEdit" type={this.state.inputPreguntaUnoType} onFocus={this.handleFocus} onBlur={this.handleBlur} onChange={this.handleChange} />
									<div id="ojoRespuestaUno" className="btn-ojo" onClick={this.toggleType}></div>
								</span>
								{ this.state.errorPreguntaUnoEdit &&
									<div className="error-wrap">
										<div className="msj-error">
											<p>{this.state.errorMsjPreguntaUnoEdit}</p>
										</div>
									</div>
								}

							</div>
						</div>
						<div className="col-xs-12">
							<div className="input-wrap">
								<label>Pregunta secreta 2</label>
								<span className="clearfix input-active">
								 {/* { this.props.pregunta2 != "" && */}
								 { true &&
									<select defaultValue={this.props.pregunta2} name="" id="pregunta_dos_edit" className="col-xs-1" onChange={this.setSelectValue}>
										<option value="0">Selecciona una pregunta</option>
										{this.props.preguntas2.map((item,i) => 
											<option key={i} value={item.id}>{item.descripcion}</option>
										)}
									</select>
								 }
								</span>
								{ this.state.errorP2 &&
									<div className="error-wrap">
										<div className="msj-error">
											<p>Campo requerido.</p>
										</div>
									</div>
								}
							</div>
						</div>
						<div className="col-xs-12">
							<div className={this.state.inputClassPreguntaDos}>
								<label>Respuesta</label>
								<span className={this.state.inputActivePreguntaDosEdit}>
									<input ref="p2" id="inputRespuestaDosEdit" type={this.state.inputPreguntaDosType} onFocus={this.handleFocus} onBlur={this.handleBlur} onChange={this.handleChange} />
									<div id="ojoRespuestaDos" className="btn-ojo" onClick={this.toggleType}></div>
								</span>
								{ this.state.errorPreguntaDosEdit &&
									<div className="error-wrap">
										<div className="msj-error">
											<p>{this.state.errorMsjPreguntaDosEdit}</p>
										</div>
									</div>
								}
							</div>
						</div>
						<div className="col-xs-12">
							<div className="text-center aceptar-cancelar-btn">
								<a onClick={this.okPreguntas}>Cancelar</a>
								<a className="orange-btn" onClick={this.checkPreguntas}>Siguiente</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>;
	}
}

export default connect(mapState, mapDispatch)(PasoUnoPreguntas);


// WEBPACK FOOTER //
// ./src/miPerfil/pasoUnoPreguntas.cmpt.js